// extracted by mini-css-extract-plugin
module.exports = {"muteButton":"style_muteButton__nGNHL","hidden":"style_hidden__1dBHc","checkbox":"style_checkbox__2za2u","text":"style_text__3QF8b","icon":"style_icon__2pgEp"};